import inDOM from 'dom-helpers/canUseDOM'
import gsap from 'gsap'

const needsResponsiveImage = inDOM && (() => {
  const img = document.createElement('img')
  const supportSrcset = ('sizes' in img) && ('srcset' in img)
  return !supportSrcset || !window.HTMLPictureElement || !!document.msElementsFromPoint
})()

const needsObjectFit = inDOM && (() => {
  const style = document.createElement('a').style
  const fitSupport = 'objectFit' in style
  const positionSupport = fitSupport && 'objectPosition' in style
  return !fitSupport || !positionSupport
})()

const needsIntersectionObserver = inDOM && typeof window.IntersectionObserver === 'undefined'

const needsResizeObserver = inDOM && !window.ResizeObserver

const needsScrollToPlugin = inDOM && !('scrollBehavior' in document.documentElement.style)

export default function loadPolyfills () {
  const promises = []

  if (needsObjectFit) {
    promises.push(import(/* webpackChunkName: 'polyfills-ls.object-fit' */ 'lazysizes/plugins/object-fit/ls.object-fit'))
  }

  if (needsResponsiveImage) {
    promises.push(import(/* webpackChunkName: 'polyfills-ls.respimg' */ 'lazysizes/plugins/respimg/ls.respimg'))
  }

  if (needsIntersectionObserver) {
    promises.push(import(/* webpackChunkName: 'polyfills-intersection-observer' */ 'intersection-observer'))
  }

  if (needsResizeObserver) {
    promises.push((async () => {
      const { default: ResizeObserver } = await import(/* webpackChunkName: 'polyfills-resize-observer' */ 'resize-observer-polyfill')
      window.ResizeObserver = ResizeObserver
    })())
  }

  if (needsScrollToPlugin) {
    promises.push((async () => {
      const { default: ScrollToPlugin } = await import(/* webpackChunkName: 'gsap-ScrollToPlugin' */ 'gsap/ScrollToPlugin')
      gsap.registerPlugin(ScrollToPlugin)
    })())
  }

  return Promise.all(promises)
}
